import service from '../../api';

export default {
    get() {
        return service.get('stripe-customer');
    },

}
